import { render, staticRenderFns } from "./PostShare.vue?vue&type=template&id=18d51209&scoped=true"
import script from "./PostShare.vue?vue&type=script&lang=js"
export * from "./PostShare.vue?vue&type=script&lang=js"
import style0 from "./PostShare.vue?vue&type=style&index=0&id=18d51209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d51209",
  null
  
)

export default component.exports